import React from "react";
import { useState, useEffect } from 'react';

//React Router
import { useNavigate } from 'react-router-dom'
import { useParams, useLocation } from 'react-router-dom' //useParams to get the ref transmitted in the url

// import created components  :
import Background from '../../../components/background/Background.jsx'
import WallyBanner from '../../../components/wallybanner/WallyBanner.jsx' //<WallyBanner />

//MUI Components
import Button from '@mui/material/Button';
import Alert from '@mui/material/Alert';
import TextField from '@mui/material/TextField';

// API fetch
import axios from "axios";
import { baseURL } from '../../../config/api-config.js';


function Login() { // component to manage the first step of shopping : choosing place and time

    const navigate = useNavigate();
    //const { destination } = useParams();

    const location = useLocation()
    const queryParameters = new URLSearchParams(location.search)
    let destination = queryParameters.get("dest");

    const [identifiant, setIdentifiant] = useState();
    const [password, setPassword] = useState();
    const [errorCode, setErrorCode] = useState(0);

    function handleFormSubmit() {
        console.log(destination);
        console.log(identifiant);
        console.log(password);

        setErrorCode(0);

        if (identifiant === undefined || identifiant.length < 2 || password === undefined || password.length < 2) {
            setErrorCode(1);
        }
        else {
            ///verifier le login
            axios.post(`${baseURL}/user/login`, {
                email: identifiant,
                password: password
            })
                .then((response) => {
                    if (response.status === 200) { //isnertion OK
                        console.log(response.data.token);
                        window.localStorage.setItem("token-nestorsurf-manager", response.data.token)
                        navigate("/" + destination);

                    }
                    else { //insertion problème
                        setErrorCode(2)
                        return response.status
                    }
                })
                .catch(error => {
                    setErrorCode(2)
                    return error
                })

        }

    }



    function emailCleaner(raw) {
        let clean = raw.toLowerCase();
        clean = clean.split(" ").join("");
        return clean
    }

    return (
        <div className="bg-relative">
            <Background ind={2} />
            <main> {/* main is positionned absolute */}
                <div className="main-relative">

                    <WallyBanner />

                    <div className="login-form">
                        <TextField
                            //fullWidth
                            className="login-form-input"
                            required
                            label="Identifiant"
                            variant="outlined"
                            name="identifiant"
                            value={identifiant}
                            onChange={e => setIdentifiant(emailCleaner(e.target.value))}
                        />
                        <TextField
                            //fullWidth
                            className="login-form-input"
                            required
                            label="password"
                            variant="outlined"
                            name="password"
                            type="password"
                            value={password}
                            onChange={e => setPassword(emailCleaner(e.target.value))}
                        />

                        {errorCode === 1 ?
                            <Alert
                                className="login-form-alert"
                                severity="error">Veillez à bien remplir correctement tous les champs.
                </Alert>
                            : null}
                        {errorCode === 2 ?
                            <Alert
                                className="login-form-alert"
                                severity="error">La combinaison identifiant / mot de passe est incorrecte
                </Alert>
                            : null}


                        <Button

                            className="login-form-bouton"
                            variant="contained"
                            onClick={_ => handleFormSubmit()}>
                            Se connecter
                </Button>

                    </div>

                </div>
            </main>
        </div>
    )
}




export default Login

